<template>
  <div class="game mt-3">
    <h4 class="text-center">Putting pieces on the board...</h4>
  </div>
</template>

<script>
export default {
  name: 'gameHomeRedirect',
  created() {
    this.$localStorage.set('gameSlug', this.$route.params.game_slug);
    this.$router.push(`/${this.$route.params.game_slug}`);
  },
};
</script>
